(() => {
  if (customElements.get('rm-header')) return;

  class RmHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.rm-header__bar');
      this.burger = this.querySelector('.rm-header__burger');
      this.overlay = document.getElementById('rm-nav-overlay');
      this.isSticky = this.dataset.sticky !== 'false';

      this.lastScrollY = window.scrollY;
      this.hideThreshold = 48;
      this.scrollTicking = false;

      this.setHeaderHeight();

      try {
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this.bar);
      } catch (_) {
        window.addEventListener('resize', () => this.setHeaderHeight());
      }

      this.onBurgerClick = this.onBurgerClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onOverlayClick = this.onOverlayClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      if (this.burger) this.burger.addEventListener('click', this.onBurgerClick);
      document.addEventListener('keydown', this.onKeydown);
      if (this.overlay) this.overlay.addEventListener('click', this.onOverlayClick);

      if (this.isSticky) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      this.desktopMQ = window.matchMedia('(min-width: 900px)');
      this.desktopMQ.addEventListener('change', this.onMediaChange);
    }

    disconnectedCallback() {
      if (this.burger) this.burger.removeEventListener('click', this.onBurgerClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.overlay) this.overlay.removeEventListener('click', this.onOverlayClick);
      window.removeEventListener('scroll', this.onScroll);
      if (this.desktopMQ) this.desktopMQ.removeEventListener('change', this.onMediaChange);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    setHeaderHeight() {
      if (!this.bar) return;
      document.documentElement.style.setProperty('--header-height', this.bar.offsetHeight + 'px');
    }

    onBurgerClick(e) {
      e.preventDefault();
      this.classList.contains('is-overlay-open') ? this.closeOverlay() : this.openOverlay();
    }

    onOverlayClick(e) {
      if (e.target.closest('a')) this.closeOverlay();
    }

    onKeydown(e) {
      if (e.key === 'Escape' && this.classList.contains('is-overlay-open')) {
        this.closeOverlay();
        if (this.burger) this.burger.focus();
      }
    }

    onMediaChange(e) {
      if (e.matches && this.classList.contains('is-overlay-open')) {
        this.closeOverlay();
      }
    }

    openOverlay() {
      this.classList.add('is-overlay-open');
      this.classList.remove('is-hidden');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
      if (this.overlay) this.overlay.removeAttribute('inert');
      document.body.classList.add('rm-nav-open');
    }

    closeOverlay() {
      this.classList.remove('is-overlay-open');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
      if (this.overlay) this.overlay.setAttribute('inert', '');
      document.body.classList.remove('rm-nav-open');
    }

    onScroll() {
      if (this.scrollTicking) return;
      this.scrollTicking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (!this.classList.contains('is-overlay-open')) {
          if (y > this.hideThreshold && y > this.lastScrollY) {
            this.classList.add('is-hidden');
          } else if (y < this.lastScrollY || y <= this.hideThreshold) {
            this.classList.remove('is-hidden');
          }
        }
        this.lastScrollY = y;
        this.scrollTicking = false;
      });
    }
  }

  customElements.define('rm-header', RmHeader);
})();
